import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const VisibleSetContainer = styled.div`
  ${tw`grid grid-cols-2 gap-4`}
`;
